import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from '@app-core/auth/guards/auth.guard';
import { NoAuthGuard } from '@app-core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
    // Redirect empty path to '/dashboard'
    { path: '', pathMatch: 'full', redirectTo: 'dashboard' },

    // Redirect signed-in user to the '/dashboard'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'dashboard' },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'forgot-password',
                loadChildren: () =>
                    import(
                        '@app-modules/auth/forgot-password/forgot-password.routes'
                    ),
            },
            {
                path: 'reset-password',
                loadChildren: () =>
                    import(
                        '@app-modules/auth/reset-password/reset-password.routes'
                    ),
            },
            {
                path: 'sign-in',
                loadChildren: () =>
                    import('@app-modules/auth/sign-in/sign-in.routes'),
            }
        ],
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver,
        },
        children: [
            {
                path: 'dashboard',
                loadChildren: () =>
                    import('@app-modules/admin/dashboard/dashboard.routes'),
            },
            {
                path: 'dashboard/invoices-detail/:id',
                loadChildren: () =>
                    import(
                        '@app-modules/admin/invoices/invoice-detail/invoice-detail.routes'
                    ),
            },
            {
                path: 'dashboard/payment-without-invoice-detail/:id',
                loadChildren: () =>
                    import(
                        '@app-modules/user/payment-without-invoice/payment-without-invoice-detail/payment-without-invoice-detail.routes'
                    ),
            },
            {
                path: 'dashboard/cash-banking-detail/:id',
                loadChildren: () =>
                    import(
                        '@app-modules/user/cash-banking/cash-banking-detail/cash-banking-detail.routes'
                    ),
            },
            // Perfil personal routes
            {
                path: 'profile',
                loadChildren: () =>
                    import('@app-modules/user/profile/profile.routes'),
            },
            // Invoices routes
            // !PPD----------------------------------------------
            {
                path: 'invoices-ppd',
                loadChildren: () =>
                    import('@app-modules/admin/invoices/invoices.routes'),
            },
            {
                path: 'invoices-ppd-correct',
                loadChildren: () =>
                    import('@app-modules/admin/invoices/invoices.routes'),
            },
            {
                path: 'invoices-ppd-not-generated',
                loadChildren: () =>
                    import('@app-modules/admin/invoices/invoices.routes'),
            },
            // ?Details PPD----------------------------------------------
            {
                path: 'invoices-ppd/detail/:id',
                loadChildren: () =>
                    import(
                        '@app-modules/admin/invoices/invoice-detail/invoice-detail.routes'
                    ),
            },
            {
                path: 'invoices-ppd-correct/detail/:id',
                loadChildren: () =>
                    import(
                        '@app-modules/admin/invoices/invoice-detail/invoice-detail.routes'
                    ),
            },
            {
                path: 'invoices-ppd-not-generated/detail/:id',
                loadChildren: () =>
                    import(
                        '@app-modules/admin/invoices/invoice-detail/invoice-detail.routes'
                    ),
            },
            // *Extras----------------------------------------------
            {
                path: 'invoices-correct/detail/:id',
                loadChildren: () =>
                    import(
                        '@app-modules/admin/invoices/invoice-detail/invoice-detail.routes'
                    ),
            },
            {
                path: 'invoices-not-generated/detail/:id',
                loadChildren: () =>
                    import(
                        '@app-modules/admin/invoices/invoice-detail/invoice-detail.routes'
                    ),
            },
            // !PUE----------------------------------------------
            {
                path: 'invoices-pue',
                loadChildren: () =>
                    import('@app-modules/admin/invoices/invoices.routes'),
            },
            {
                path: 'invoices-pue-correct',
                loadChildren: () =>
                    import('@app-modules/admin/invoices/invoices.routes'),
            },
            {
                path: 'invoices-pue-not-generated',
                loadChildren: () =>
                    import('@app-modules/admin/invoices/invoices.routes'),
            },
            // ?Details PPD----------------------------------------------
            {
                path: 'invoices-pue/detail/:id',
                loadChildren: () =>
                    import(
                        '@app-modules/admin/invoices/invoice-detail/invoice-detail.routes'
                    ),
            },
            {
                path: 'invoices-pue-correct/detail/:id',
                loadChildren: () =>
                    import(
                        '@app-modules/admin/invoices/invoice-detail/invoice-detail.routes'
                    ),
            },
            {
                path: 'invoices-pue-not-generated/detail/:id',
                loadChildren: () =>
                    import(
                        '@app-modules/admin/invoices/invoice-detail/invoice-detail.routes'
                    ),
            },
            // *Extras----------------------------------------------
            {
                path: 'invoices-correct/detail/:id',
                loadChildren: () =>
                    import(
                        '@app-modules/admin/invoices/invoice-detail/invoice-detail.routes'
                    ),
            },
            {
                path: 'invoices-not-generated/detail/:id',
                loadChildren: () =>
                    import(
                        '@app-modules/admin/invoices/invoice-detail/invoice-detail.routes'
                    ),
            },
            // !------------------------------------
            {
                path: 'new-invoice',
                loadChildren: () =>
                    import('@app-modules/admin/invoices/invoice-form/invoice-form.routes'),
            },
            {
                path: 'new-invoice-ppd',
                loadChildren: () =>
                    import('@app-modules/admin/invoices/invoice-form/invoice-form.routes'),
            },
            {
                path: 'new-invoice-pue',
                loadChildren: () =>
                    import('@app-modules/admin/invoices/invoice-form/invoice-form.routes'),
            },

            // Requests routes
            {
                path: 'requests',
                loadChildren: () =>
                    import('@app-modules/user/requests/requests.routes'),
            },
            {
                path: 'requests/detail/:id',
                loadChildren: () =>
                    import(
                        '@app-modules/user/requests/request-detail/request-detail.routes'
                    ),
            },
            {
                path: 'new-request',
                loadChildren: () =>
                    import('@app-modules/user/requests/request-form/request.form.routes'),
            },

            // Cash Banking routes
            {
                path: 'cash-banking',
                loadChildren: () =>
                    import('@app-modules/user/cash-banking/cash-banking.routes'),
            },
            {
                path: 'cash-banking-process',
                loadChildren: () =>
                    import('@app-modules/user/cash-banking/cash-banking.routes'),
            },
            {
                path: 'cash-banking-finalized',
                loadChildren: () =>
                    import('@app-modules/user/cash-banking/cash-banking.routes'),
            },
            {
                path: 'cash-banking/detail/:id',
                loadChildren: () =>
                    import(
                        '@app-modules/user/cash-banking/cash-banking-detail/cash-banking-detail.routes'
                    ),
            },
            {
                path: 'new-cash-banking',
                loadChildren: () =>
                    import(
                        '@app-modules/user/cash-banking/cash-banking-form/cash-banking-form.routes'),
            },

            // Payment Without routes
            {
                path: 'payment-without',
                loadChildren: () =>
                    import('@app-modules/user/payment-without/payment-without.routes'),
            },
            {
                path: 'payment-without-process',
                loadChildren: () =>
                    import('@app-modules/user/payment-without/payment-without.routes'),
            },
            {
                path: 'payment-without-finalized',
                loadChildren: () =>
                    import('@app-modules/user/payment-without/payment-without.routes'),
            },
            {
                path: 'payment-without/detail/:id',
                loadChildren: () =>
                    import(
                        '@app-modules/user/payment-without/payment-without-detail/payment-without-detail.routes'
                    ),
            },
            {
                path: 'new-payment-without',
                loadChildren: () =>
                    import(
                        '@app-modules/user/payment-without/payment-without-form/payment-without-form.routes'
                    ),
            },

            // Payment Vouchers routes
            {
                path: 'payment-vouchers',
                loadChildren: () =>
                    import(
                        '@app-modules/user/payment-vouchers/payment-vouchers.routes'
                    ),
            },
            {
                path: 'payment-vouchers-process',
                loadChildren: () =>
                    import(
                        '@app-modules/user/payment-vouchers/payment-vouchers.routes'
                    ),
            },
            {
                path: 'payment-vouchers-finalized',
                loadChildren: () =>
                    import(
                        '@app-modules/user/payment-vouchers/payment-vouchers.routes'
                    ),
            },
            {
                path: 'payment-vouchers/detail/:id',
                loadChildren: () =>
                    import(
                        '@app-modules/user/payment-vouchers/payment-vouchers-detail/payment-vouchers-detail.routes'
                    ),
            },
            {
                path: 'payment-vouchers/create',
                loadChildren: () =>
                    import(
                        '@app-modules/user/payment-vouchers/payment-vouchers-create/payment-vouchers-create.routes'
                    ),
            },
            {
                path: 'payment-vouchers-process/create',
                loadChildren: () =>
                    import(
                        '@app-modules/user/payment-vouchers/payment-vouchers-create/payment-vouchers-create.routes'
                    ),
            },
            {
                path: 'payment-vouchers-finalized/create',
                loadChildren: () =>
                    import(
                        '@app-modules/user/payment-vouchers/payment-vouchers-create/payment-vouchers-create.routes'
                    ),
            },

            // Payment Cash Banking routes
            // main
            {
                path: 'payment-cash-banking',
                loadChildren: () =>
                    import('@app-modules/user/payment-cash-banking/payment-cash-banking.routes'),
            },
            {
                path: 'payment-cash-banking-process',
                loadChildren: () =>
                    import('@app-modules/user/payment-cash-banking/payment-cash-banking.routes'),
            },
            {
                path: 'payment-cash-banking-finalized',
                loadChildren: () =>
                    import('@app-modules/user/payment-cash-banking/payment-cash-banking.routes'),
            },
            // details
            {
                path: 'payment-cash-banking/detail/:id',
                loadChildren: () =>
                    import(
                        '@app-modules/user/payment-cash-banking/payment-cash-banking-detail/payment-cash-banking-detail.routes'
                    ),
            },
            {
                path: 'payment-cash-banking-process/detail/:id',
                loadChildren: () =>
                    import(
                        '@app-modules/user/payment-cash-banking/payment-cash-banking-detail/payment-cash-banking-detail.routes'
                    ),
            },
            {
                path: 'payment-cash-banking-finalized/detail/:id',
                loadChildren: () =>
                    import(
                        '@app-modules/user/payment-cash-banking/payment-cash-banking-detail/payment-cash-banking-detail.routes'
                    ),
            },
            // form
            {
                path: 'new-payment-cash-banking',
                loadChildren: () =>
                    import(
                        '@app-modules/user/payment-cash-banking/payment-cash-banking-form/payment-cash-banking-form.routes'
                    ),
            },

            // Payment Without Invoice routes
            // main
            {
                path: 'payment-without-invoice',
                loadChildren: () =>
                    import('@app-modules/user/payment-without-invoice/payment-without-invoice.routes'),
            },
            {
                path: 'payment-without-invoice-process',
                loadChildren: () =>
                    import('@app-modules/user/payment-without-invoice/payment-without-invoice.routes'),
            },
            {
                path: 'payment-without-invoice-finalized',
                loadChildren: () =>
                    import('@app-modules/user/payment-without-invoice/payment-without-invoice.routes'),
            },
            // details
            {
                path: 'payment-without-invoice/detail/:id',
                loadChildren: () =>
                    import(
                        '@app-modules/user/payment-without-invoice/payment-without-invoice-detail/payment-without-invoice-detail.routes'
                    ),
            },
            {
                path: 'payment-without-invoice-process/detail/:id',
                loadChildren: () =>
                    import(
                        '@app-modules/user/payment-without-invoice/payment-without-invoice-detail/payment-without-invoice-detail.routes'
                    ),
            },
            {
                path: 'payment-without-invoice-finalized/detail/:id',
                loadChildren: () =>
                    import(
                        '@app-modules/user/payment-without-invoice/payment-without-invoice-detail/payment-without-invoice-detail.routes'
                    ),
            },
            // form
            {
                path: 'new-payment-without-invoice',
                loadChildren: () =>
                    import(
                        '@app-modules/user/payment-without-invoice/payment-without-invoice-form/payment-without-invoice-form.routes'
                    ),
            },
            // Balance routes
            {
                path: 'balance',
                loadChildren: () =>
                    import('@app-modules/admin/balance/balance.routes'),
            },
            {
                path: 'balance/detail/:id',
                loadChildren: () =>
                    import('@app-modules/admin/balance/balance-detail/balance-detail.routes'),
            },


            // Returns routes - all
            {
                path: 'return-all',
                loadChildren: () =>
                    import('@app-modules/user/return/return.routes'),
            },
            {
                path: 'return-all/detail/:id',
                loadChildren: () =>
                    import('@app-modules/user/return/return-detail/return-detail.routes'),
            },

            // Return routes - Cash (Efectivo)
            {
                path: 'return-cash-all',
                loadChildren: () =>
                    import('@app-modules/user/return/return.routes'),
            },
            {
                path: 'return-cash-all/detail/:id',
                loadChildren: () =>
                    import('@app-modules/user/return/return-detail/return-detail.routes'),
            },
            {
                path: 'return-cash-local',
                loadChildren: () =>
                    import('@app-modules/user/return/return.routes'),
            },
            {
                path: 'return-cash-local/detail/:id',
                loadChildren: () =>
                    import('@app-modules/user/return/return-detail/return-detail.routes'),
            },
            {
                path: 'return-cash-values',
                loadChildren: () =>
                    import('@app-modules/user/return/return.routes'),
            },
            {
                path: 'return-cash-values/detail/:id',
                loadChildren: () =>
                    import('@app-modules/user/return/return-detail/return-detail.routes'),
            },
            {
                path: 'return-cash-foreign',
                loadChildren: () =>
                    import('@app-modules/user/return/return.routes'),
            },
            {
                path: 'return-cash-foreign/detail/:id',
                loadChildren: () =>
                    import('@app-modules/user/return/return-detail/return-detail.routes'),
            },
            {
                path: 'return-cash-deposit',
                loadChildren: () =>
                    import('@app-modules/user/return/return.routes'),
            },
            {
                path: 'return-cash-deposit/detail/:id',
                loadChildren: () =>
                    import('@app-modules/user/return/return-detail/return-detail.routes'),
            },
            // Return routes - Transfers (Transferencias)
            {
                path: 'return-transfers-all',
                loadChildren: () =>
                    import('@app-modules/user/return/return.routes'),
            },
            {
                path: 'return-transfers-all/detail/:id',
                loadChildren: () =>
                    import('@app-modules/user/return/return-detail/return-detail.routes'),
            },
            {
                path: 'return-transfers-national',
                loadChildren: () =>
                    import('@app-modules/user/return/return.routes'),
            },
            {
                path: 'return-transfers-national/detail/:id',
                loadChildren: () =>
                    import('@app-modules/user/return/return-detail/return-detail.routes'),
            },
            {
                path: 'return-transfers-international',
                loadChildren: () =>
                    import('@app-modules/user/return/return.routes'),
            },
            {
                path: 'return-transfers-international/detail/:id',
                loadChildren: () =>
                    import('@app-modules/user/return/return-detail/return-detail.routes'),
            },
            {
                path: 'return-transfers-payroll',
                loadChildren: () =>
                    import('@app-modules/user/return/return.routes'),
            },
            {
                path: 'return-transfers-payroll/detail/:id',
                loadChildren: () =>
                    import('@app-modules/user/return/return-detail/return-detail.routes'),
            },
            {
                path: 'return-transfers-assimilated',
                loadChildren: () =>
                    import('@app-modules/user/return/return.routes'),
            },
            {
                path: 'return-transfers-assimilated/detail/:id',
                loadChildren: () =>
                    import('@app-modules/user/return/return-detail/return-detail.routes'),
            },
            {
                path: 'return-transfers-forex',
                loadChildren: () =>
                    import('@app-modules/user/return/return.routes'),
            },
            {
                path: 'return-transfers-forex/detail/:id',
                loadChildren: () =>
                    import('@app-modules/user/return/return-detail/return-detail.routes'),
            },

            {
                path: 'return-cash-deposit-all',
                loadChildren: () =>
                    import('@app-modules/user/return/return.routes'),
            },
            {
                path: 'return-cash-deposit-all/detail/:id',
                loadChildren: () =>
                    import('@app-modules/user/return/return-detail/return-detail.routes'),
            },

            {
                path: 'new-return',
                loadChildren: () =>
                    import('@app-modules/user/return/return-form/return-form.routes'),
            },
            

        ],
    },
];
